import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UntypedFormBuilder, UntypedFormGroup, NgForm, Validators, FormControl } from '@angular/forms';
import { HttpClient, HttpParams} from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';
import { ProjectService } from 'src/app/_services/project.service';

@Component({
  selector: 'app-add-parent-module',
  templateUrl: './add-parent-module.component.html',
  styleUrls: ['./add-parent-module.component.scss']
})
export class AddParentModuleComponent implements OnInit {

  addParentTestModuleForm:UntypedFormGroup;
  projectName: any;
  submitted= false;
  url: string;
  title: any;
  projectId: any;
  parentTestDataId: any;
  TestDirData: any;
  constructor(@Inject(MAT_DIALOG_DATA) public data,
  private formBuilder: UntypedFormBuilder,
  private http: HttpClient,
  private toastrService: ToastrService,
  private projectService: ProjectService,
  public dialogRef: MatDialogRef< AddParentModuleComponent>) { 
    this.url=environment.baseUrl;
    
    this.title= data.message.projectName; 
     this.projectId= data.message.id;
    //  this.parentTestDataId= data.message.items[0].parentTestDataId;
    
  }
  ngOnInit() {
    this.loadForm();
  }


  loadForm(){
    this.addParentTestModuleForm = this.formBuilder.group({
      name:['',[
        Validators.required,
        Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/)
    ]],
      comment:['']
    })
  }
  get f() { return this.addParentTestModuleForm.controls; }
  onPrentModuleAdd(){
    this.submitted = true;
    if(this. addParentTestModuleForm.invalid){
      return;
    }
    var objFormval = this.addParentTestModuleForm.value;

    const ValueForAdd={
      // dependent: "false", 
      title: objFormval.name, 
      comment: objFormval.comment,
      projectId: this.projectId,
      //  parentTestDataId: this.parentTestDataId
    }

    if (! /^[^:|*?<>/\"]+$/.test(objFormval.name)) {
      this.toastrService.clear();
      this.toastrService.warning('Module Name is not Valid, Name can not contain /[<>:"\/\\|?*'); 
      return;
    }
    
    //console.log(objFormval); //http://beatblipdemo.agreeya.net /HuLoopRest/huloop/test/addTestDir
    //console.log("");
    //console.log(ValueForAdd);
 
      this.http.post(this.url + '/HuLoopRest/huloop/test/addTestDir'   ,ValueForAdd). subscribe((data) => {
        if(data) {
             this.toastrService.clear();
             this.toastrService.success( ' Module Added successfully'); 
          //console.log('--------------------')
            //console.log("projectData path Check", data); 
           this.TestDirData = data;
           //console.log(this.TestDirData);
           //console.log(this.TestDirData.id);
            const ValueForAdd1={
              dependent: "false", 
              title: 'Default Suite', 
              comment: 'suite',
               projectId: this.TestDirData.projectId,
               parentTestDataId: this.TestDirData.id
            }
            
            //console.log("");
            //console.log(ValueForAdd1);//http://beatblipdemo.agreeya.net /HuLoopRest/huloop/test/addTestFile
            
            this.http.post(this.url + '/HuLoopRest/huloop/test/addTestFile'   ,ValueForAdd1). subscribe((data) => {
              if(data) { 
                  //console.log("projectData", data); 
                  this.projectService.loadSuggestion.next(true);
                  }  
             });
  
            }  
       });
   
   
    
    
    
  }
  closeDialog() {
    this.dialogRef.close(false);
  }
}
